import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { type AnalyticsParams, statsApi } from '~/entities/stats/api/stats'
import { QueryKey, queryKey } from '~/shared/lib/query-keys'
import { MINUTES } from '~/shared/lib/time-constants'

export function useEventAnalytics(
  businessId: string,
  eventId: string,
  params: AnalyticsParams,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: queryKey(
      QueryKey.ANALYTICS,
      'event',
      eventId,
      params.granularity,
      params.from,
      params.to,
    ),
    queryFn: () => statsApi.getEventAnalytics(businessId, eventId, params),
    staleTime: 5 * MINUTES,
    placeholderData: keepPreviousData,
    enabled: !!businessId && !!eventId && options?.enabled !== false,
  })
}
